// extracted by mini-css-extract-plugin
module.exports = {"container":"hV","image":"hW","title":"hX","date":"hY"};